export default __webpack_public_path__ + "assets/1a2300fc2be3bef735345cf5a3c68eb4.png";